export const TEXT = "text";
export const EMAIL = "email";
export const PASSWORD = "password";
